import React from "react";
import CompanyAnalytics from "../../components/CompanyAnalytics";
import { useLanguage } from "../../context/LanguageContext";

function StatisticsPage({ companyId }) {
  const { t } = useLanguage();
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-xl shadow-sm p-5">
        <h2 className="text-lg font-semibold text-gray-800">{t("stats_title")}</h2>
        <p className="text-gray-500 text-sm mt-0.5">
          {t("stats_subtitle")}
        </p>
      </div>
      <CompanyAnalytics company={{ id: companyId }} />
    </div>
  );
}

export default StatisticsPage;
